import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

const Logo = (
  props: {
    height?: number | string
    sx?: SxProps<Theme>
  }
) => {
  const src = `${process.env.PUBLIC_URL}/logo_black.png`
  const { height, ...rest } = props
  return (
    <Box
      {...rest}
    >
      <img
        src={src}
        alt="logo"
        height={height ?? 48}
        style={{
          paddingBottom: '8px',
          paddingTop: '8px'
        }}
      />
    </Box>
  )
}

export default Logo;